<template>
  <v-card flat class="r5">
    <v-container grid-list-md fluid :class="classProp">
      <v-layout row wrap justify-space-between>
        <div class="di-flex align-center flex xs12 px-2 mb-4">
          <strong class="body-2">{{ $t("receive_remittance_form") }} :</strong>
          <v-divider class="ml-2"></v-divider>
        </div>
        <v-flex xs12 :md6="!edit">
          <v-layout row wrap>
            <v-date
              input_id="trc_date"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="value.date"
              class="flex xs12 sm6"
              value-type="YYYY-MM-DD"
              :placeholder="$t('date')"
              @input="$emit('date-changed')"
              :disabled-date="disableBackDate"
            />
            <v-date
              type="time"
              label="time"
              input_id="trc_time"
              format="HH:mm:ss"
              :clearable="false"
              v-model="value.time"
              value-type="HH:mm:ss"
              class="flex xs12 sm6"
              :placeholder="$t('time')"
              :disabled-time="disableBackDate"
            />
            <async-autocomplete
              outline
              item-value="id"
              placeholder=" "
              class="flex xs12 sm6"
              item-text="full_name"
              :label="$t('customer')"
              v-validate="'required'"
              url="/transfers/create"
              queries="send=true"
              @setItem="setCustomer"
              :data-vv-name="'customer'"
              v-model="value.customer_id"
              :data-vv-as="$t('customer')"
              :edit-append="editAppend"
              :append-item="appendCustomer"
              :error-messages="errors.collect('customer')"
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t(data.item.type)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </async-autocomplete>
            <!-- disabled -->
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('sender_full_name')"
              v-model="value.details.name"
            />
            <!-- disabled -->
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('father_name')"
              v-model="value.details.father_name"
            />

            <v-combobox
              outline
              multiple
              small-chips
              placeholder=" "
              :label="$t('phones')"
              class="flex xs12 sm6"
              v-model="value.details.phones"
            />
            <v-checkbox
              outline
              singleLine
              hideDetails
              color="primary"
              v-model="showExtra"
              class="flex xs12 sm6"
              :label="$t('full_details_of_sender')"
            />
            <template v-if="showExtra">
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('place_of_birth')"
                v-model="value.details.place_of_birth"
              />
              <v-date
                :has-icon="false"
                :single-line="false"
                class="flex xs12 sm6 pt-0"
                input_id="date_of_birth"
                :placeholder="$t('date_of_birth')"
                v-model="value.details.date_of_birth"
                value-type="YYYY-MM-DD"
                format="YYYY-MM-DD"
              />
              <v-radio-group row class="flex xs12 sm6 mb-4" v-model="value.details.doctype">
                <v-radio label="Tazkira" value="tazkira"></v-radio>
                <v-radio label="Passport" value="passport"></v-radio>
                <v-radio label="License No" value="license"></v-radio>
              </v-radio-group>
              <v-text-field
                outline
                :label="$t('docno')"
                class="flex xs12 sm6"
                v-model="value.details.docno"
                placeholder="Passport/Tazkira/License"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('nature_of_business')"
                v-if="value.details.doctype == 'license'"
                v-model="value.details.nature_of_business"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('nationality')"
                v-if="value.details.doctype != 'license'"
                v-model="value.details.nationality"
              />
              <v-date
                :has-icon="false"
                :single-line="false"
                class="flex xs12 sm6"
                input_id="issue_date"
                :placeholder="$t('issue_date')"
                v-model="value.details.issue_date"
                value-type="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-if="value.details.doctype != 'tazkira'"
              />
              <v-date
                :has-icon="false"
                class="flex xs12 sm6"
                :single-line="false"
                input_id="expire_date"
                :placeholder="$t('expire_date')"
                v-model="value.details.expire_date"
                value-type="YYYY-MM-DD"
                v-if="value.details.doctype != 'tazkira'"
                format="YYYY-MM-DD"
              />

              <!-- <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('occupation')"
              v-model="value.details.occupation"
              v-if="value.details.doctype != 'license'"
              />-->
              <!-- <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('relationship')"
              v-model="value.details.relationship"
            />
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('source_of_fund')"
              v-model="value.details.source_of_fund"
            />
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('purpose_of_transaction')"
              v-model="value.details.purpose_of_transaction"
            />
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              class="flex xs12"
              :label="$t('address')"
              v-model="value.details.address"
              />-->
            </template>
            <div class="di-flex align-center flex xs12 px-2 mb-4">
              <strong class="body-2">{{ $t("receiver_details") }} :</strong>
              <v-divider class="ml-2"></v-divider>
            </div>
            <async-autocomplete
              outline
              item-value="id"
              placeholder=" "
              queries="send=true"
              class="flex xs12 sm6"
              item-text="full_name"
              :label="$t('customer')"
              v-validate="'required'"
              @setItem="setReceiver"
              url="/transfers/create"
              :data-vv-name="'customer'"
              :data-vv-as="$t('customer')"
              :append-item="appendCustomer"
              :edit-append="editAppendReceiver"
              v-model="value.receiver_customer_id"
              :error-messages="errors.collect('customer')"
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t(data.item.type)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </async-autocomplete>
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              v-validate="'required'"
              :label="$t('full_name')"
              :data-vv-as="$t('full_name')"
              :data-vv-name="'receiver_name'"
              v-model="value.details.receiver_name"
              :error-messages="errors.collect('receiver_name')"
            />
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('father_name')"
              v-model="value.details.receiver_father_name"
            />
            <v-text-field
              outline
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('nationality')"
              v-model="value.details.receiver_nationality"
            />
            <v-combobox
              outline
              multiple
              small-chips
              placeholder=" "
              :label="$t('phones')"
              class="flex xs12 sm6"
              v-model="value.details.receiver_phones"
            />
            <v-checkbox
              outline
              singleLine
              hideDetails
              color="primary"
              v-model="showExtra1"
              class="flex xs12 sm6"
              :label="$t('full_details_of_receiver')"
            />
            <template v-if="showExtra1">
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('place_of_birth')"
                v-model="value.details.receiver_place_of_birth"
              />
              <v-date
                input_id="date_of_bir"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                class="flex xs12 sm6 pt-0"
                :placeholder="$t('date_of_birth')"
                v-model="value.details.receiver_date_of_birth"
              />
              <v-radio-group row class="flex xs12 mb-4" v-model="value.details.receiver_doctype">
                <v-radio label="Passport" value="passport"></v-radio>
                <v-radio label="Tazkira" value="tazkira"></v-radio>
                <v-radio label="License No" value="license"></v-radio>
              </v-radio-group>
              <v-text-field
                outline
                :label="$t('docno')"
                class="flex xs12"
                v-model="value.details.receiver_docno"
                placeholder="Passport/Tazkira/License"
              />
              <!-- <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('occupation')"
                v-model="value.details.receiver_occupation"
                v-if="value.details.receiver_doctype != 'license'"
              />-->
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('nature_of_business')"
                v-if="value.details.receiver_doctype == 'license'"
                v-model="value.details.receiver_nature_of_business"
              />
              <v-date
                input_id="issuer_date"
                format="YYYY-MM-DD"
                class="flex xs12 sm6"
                value-type="YYYY-MM-DD"
                :placeholder="$t('issue_date')"
                v-model="value.details.receiver_issue_date"
              />
              <v-date
                input_id="exp_date"
                format="YYYY-MM-DD"
                class="flex xs12 sm6"
                value-type="YYYY-MM-DD"
                :placeholder="$t('expire_date')"
                v-model="value.details.receiver_expire_date"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('occupation')"
                v-model="value.details.receiver_occupation"
                v-if="value.details.doctype != 'license'"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('relationship')"
                v-model="value.details.receiver_relationship"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('source_of_fund')"
                v-model="value.details.receiver_source_of_fund"
              />
              <v-text-field
                outline
                placeholder=" "
                class="flex xs12 sm6"
                :label="$t('purpose_of_transaction')"
                v-model="value.details.receiver_purpose_of_transaction"
              />
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                class="flex xs12"
                :label="$t('address')"
                v-model="value.details.receiver_address"
              />
            </template>

            <div class="di-flex align-center flex xs12 px-2 mb-4">
              <strong class="body-2">{{ $t("transaction_details") }} :</strong>
              <v-divider class="ml-2"></v-divider>
            </div>
            <v-autocomplete
              outline
              placeholder=" "
              item-value="id"
              persistent-hint
              :items="branchs"
              item-text="full_name"
              :label="$t('source')"
              v-validate="'required'"
              :data-vv-name="'sender'"
              @change="setDescription"
              v-model="value.sender_id"
              :data-vv-as="$t('source')"
              class="flex xs12 sm6 right-hint"
              :error-messages="errors.collect('source')"
              :hint="
                senderAccountBalance
                  | currency({ symbol: smbl(value.sale_currency_id) })
              "
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t(data.item.type)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
            <v-autocomplete
              outline
              placeholder=" "
              item-value="id"
              persistent-hint
              item-text="full_name"
              v-validate="'required'"
              :items="receiversAccount"
              :label="$t('destination')"
              v-model="value.receiver_id"
              @change="changeFormNumber()"
              class="flex xs12 sm6 right-hint"
              :data-vv-name="'destination'"
              :data-vv-as="$t('destination')"
              :error-messages="errors.collect('destination')"
              :hint="
                receiverAccountBalance
                  | currency({ symbol: smbl(value.buy_currency_id) })
              "
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.full_name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="$t(data.item.type)"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
            <!-- <v-autocomplete
              outline
              item-value="id"
              placeholder=" "
              item-text="name"
              :items="currencies"
              class="flex xs12 sm6"
              v-validate="'required'"
              :label="$t('receiver_currency')"
              @change="amountChanged(false, true)"
              :data-vv-name="'receiver_currency'"
              :data-vv-as="$t('receiver_currency')"
              v-model="value.receiver_currency_id"
              :error-messages="errors.collect('receiver_currency')"
            />-->
            <v-text-field
              outline
              type="number"
              persistentHint
              placeholder=" "
              :label="$t('amount')"
              v-model="value.amount"
              v-validate="'required'"
              :data-vv-name="'amount'"
              :data-vv-as="$t('amount')"
              @input="amountChanged(false)"
              :hint="value.amount | toWord"
              class="flex xs12 sm6 mb-3 capitalize"
              :error-messages="errors.collect('amount')"
            />
            <v-autocomplete
              outline
              placeholder=" "
              item-value="id"
              item-text="name"
              :items="currencies"
              class="flex xs12 sm6"
              v-validate="'required'"
              @change="currencyChanged"
              v-model="value.currency_id"
              :label="$t('sender_currency')"
              :data-vv-name="'sender_currency'"
              :data-vv-as="$t('sender_currency')"
              :error-messages="errors.collect('sender_currency')"
            />
            <!-- <v-text-field
              outline
              placeholder=" "
              :label="$t('amount')"
              class="flex xs12 sm6"
              v-validate="'required'"
              v-model="value.exchanged"
              :data-vv-as="$t('amount')"
              :data-vv-name="'exchanged'"
              @input="amountChanged(true)"
              v-currency="{ currency: null }"
              :error-messages="errors.collect('exchanged')"
            />-->
            <!-- <v-text-field
              outline
              type="number"
              placeholder=" "
              :label="$t('rate')"
              class="flex xs12"
              v-model="value.rate"
              v-validate="'required'"
              :data-vv-name="'rate'"
              :data-vv-as="$t('rate')"
              @input="amountChanged(false)"
              :error-messages="errors.collect('rate')"
            />-->

            <v-text-field
              outline
              type="number"
              persistentHint
              @input="setPercentage"
              data-vv-name="commission_amount"
              v-model="value.commission_amount"
              :label="$t('received_commission')"
              :placeholder="$t('received_commission')"
              :hint="value.commission_amount | toWord"
              class="flex xs6 sm4 has_currency mb-3 capitalize"
            >
              <v-menu offset-y slot="append">
                <a slot="activator" class="mx-2 mt-2 font-weight-medium subheading align-center">
                  <span>{{ smbl(value.commission_currency_id) }}</span>
                </a>
                <v-list>
                  <v-list-tile
                    :key="index"
                    v-for="(item, index) in currencies"
                    @click="value.commission_currency_id = item.id"
                  >
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-text-field>
            <v-text-field
              outline
              type="number"
              persistentHint
              placeholder="%"
              :label="$t('percentage')"
              @input="setCommissionAmount"
              class="flex xs6 sm2 mb-3 capitalize"
              v-model="value.commission_percentage"
              :hint="value.commission_percentage | toWord"
            />
            <v-text-field
              outline
              type="number"
              persistentHint
              @input="setPaidPercentage"
              :label="$t('paid_commission')"
              data-vv-name="commission_amount"
              :placeholder="$t('paid_commission')"
              v-model="value.paid_commission_amount"
              :hint="value.paid_commission_amount | toWord"
              class="flex xs6 sm4 has_currency mb-3 capitalize"
              @keyup.enter="setPercentage('paid_commission_percentage')"
            >
              <v-menu offset-y slot="append">
                <a slot="activator" class="mx-2 mt-2 font-weight-medium subheading align-center">
                  <span>{{ smbl(value.paid_commission_currency_id) }}</span>
                </a>
                <v-list>
                  <v-list-tile
                    :key="index"
                    v-for="(item, index) in currencies"
                    @click="value.paid_commission_currency_id = item.id"
                  >
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-text-field>
            <v-text-field
              outline
              type="number"
              persistentHint
              placeholder="%"
              :label="$t('percentage')"
              @input="setPaidCommissionAmount"
              class="flex xs6 sm2 mb-3 capitalize"
              v-model="value.paid_commission_percentage"
              @keyup.enter="setPercentage('commission_amount')"
              :hint="value.paid_commission_percentage | toWord"
            />
            <!-- <v-text-field
              outline
              type="number"
              placeholder=" "
              class="flex xs12 sm6"
              v-validate="'required'"
              @input="setDescription"
              data-vv-name="received_number"
              v-model="value.received_number"
              :label="$t('received_transfer_number')"
              :data-vv-as="$t('received_transfer_number')"
              :error-messages="errors.collect('received_number')"
            />-->
            <v-text-field
              outline
              type="number"
              placeholder=" "
              data-vv-name="number"
              v-model="value.number"
              v-validate="'required'"
              @input="setDescription"
              class="flex xs12 sm6 mb-3"
              :label="$t('transfer_number')"
              :data-vv-as="$t('transfer_number')"
              :error-messages="errors.collect('number')"
            />
            <v-combobox
              outline
              placeholder=" "
              :label="$t('risk_profile')"
              v-model="value.risk_category"
              :items="['Low', 'Medium', 'High']"
              class="flex xs12 sm6 mb-3 capitalize"
            />
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              class="flex xs12"
              :label="$t('description')"
              v-model="value.description"
            />
            <!-- <v-autocomplete
              outline
              placeholder=" "
              class="flex xs12 sm4"
              v-validate="'required'"
              :label="$t('risk_category')"
              v-model="value.risk_category"
              :items="['Low', 'Medium', 'High']"
              :data-vv-name="'risk_category'"
              :data-vv-as="$t('risk_category')"
              :error-messages="errors.collect('risk_category')"
            />-->
            <v-checkbox
              single-line
              hide-details
              color="primary"
              class="flex xs12 sm3"
              v-model="value.done"
              :label="$t('submit_transfer')"
            />
            <v-checkbox
              single-line
              hide-details
              color="primary"
              :label="$t('pep')"
              v-model="value.pep"
              class="flex xs12 sm2"
            />
            <v-checkbox
              single-line
              hide-details
              color="primary"
              :label="$t('str')"
              v-model="value.str"
              class="flex xs12 sm2"
            />
            <v-checkbox
              single-line
              hide-details
              color="primary"
              class="flex xs12 sm5"
              :label="$t('suction_checked')"
              v-model="value.suction_checked"
            />
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 mt-2>
              <v-btn
                dark
                raised
                class="mx-0"
                @click="save"
                color="primary"
                :loading="loading"
              >{{ $t("save") }}</v-btn>
              <v-btn dark outline color="primary" @click="save(false)" :loading="loading">
                <v-icon class="mx-2">print</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 :md4="!edit" class="mt-3 hidden-sm-and-down">
          <v-layout row wrap class="justify-center mb-3">
            <v-flex xs12 class="di-flex align-center justify-space-between">
              <div class="caption">
                <strong>{{ $t("files") }}</strong>
                <br />
                {{ $t("file_max_notation") }}
              </div>
              <file-chooser text color="secondary" v-model="value.files" />
            </v-flex>
            <v-flex xs12 v-if="value.files && value.files.length > 0" class="mt-3">
              <file-viewer :files="value.files" />
            </v-flex>
          </v-layout>
          <customer-tile :customer="sender" v-if="!edit" />
          <customer-tile :customer="receiver" class="mt-3" v-if="!edit" />
        </v-flex>
        <v-flex xs12 md5 v-show="false">
          <receive-transfer-bill
            v-bind="{
              transfer: { ...value, exchanged },
              receiver,
              sender,
            }"
            ref="bill"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { customersMixin, printBill, exchange } from "@/mixins/index.js";
import curjs from "currency.js";
export default {
  name: "receiveTransferForm",
  mixins: [customersMixin, printBill, exchange],
  props: {
    classProp: { default: "" },
    value: {
      default: () => ({
        details: {}
      })
    }
  },

  data() {
    return {
      loading: false,
      showExtra: false,
      showExtra1: false,
      customer: {
        type: "new_customer",
        accounts: [],
        details: {}
      },
      receiver_customer: {
        type: "new_customer",
        accounts: [],
        details: {}
      }
    };
  },

  computed: {
    editAppend() {
      if (this.value.id) return this.value.customer;
      return false;
    },
    editAppendReceiver() {
      if (this.value.id) return this.value.receiver_customer;
      return false;
    },
    appendCustomer() {
      return {
        details: [],
        id: this.system.id,
        type: "new_customer",
        full_name: this.$t("new_customer"),
        image: require("@/assets/images/userplaceholder.svg"),
        reg_id: "Ex_" + (this.system.last_customer_reg_number + 1)
      };
    },
    edit: vm => vm.value.id > 0,
    editAppend() {
      if (this.value.id) return this.value.customer;
      return false;
    },
    currencies: vm => vm.initialData.currencies,
    system() {
      let system = this.initialData.customers.find(x => x.type == "system");
      return system ? system : {};
    },

    receiversAccount() {
      let accounts = this.initialData.customers.filter(
        x =>
          x.type != "DailyProfit" &&
          x.type != "external" &&
          x.type != "income" &&
          x.type != "expense" &&
          x.type != "stock" &&
          x.type != "commission" &&
          x.id != this.value.sender_id
      );
      if (
        this.customer.type != "new_customer" &&
        this.customer.type != "external" &&
        this.customer.type != "system"
      )
        accounts.unshift({
          id: this.customer.id,
          full_name: this.$t("customer_account"),
          image: require("@/assets/images/userplaceholder.svg")
        });
      return accounts;
    },

    isNewCustomer: vm => vm.customer.type == "new_customer",

    branchs: vm =>
      vm.initialData.customers.filter(
        x => x.type == "branch" || x.type == "saraf"
      ),

    sender: vm =>
      vm.initialData.customers.find(x => x.id == vm.value.sender_id) || {
        accounts: []
      },

    receiver: vm =>
      vm.initialData.customers.find(
        x => x.id == vm.value.receiver_id && x.type != "expense"
      ) || { accounts: [] },

    senderAccountBalance() {
      let a = this.sender.accounts.find(
        x => x.currency_id == this.value.currency_id
      ) || { balance: 0 };
      return a.balance;
    },

    receiverAccountBalance() {
      let a = this.receiver.accounts.find(
        x => x.currency_id == this.value.receiver_currency_id
      ) || { balance: 0 };
      return a.balance;
    },
    amountValidate() {
      return this.value.done
        ? `required|max_value:${this.receiverAccountBalance}`
        : "required";
    },

    fromCurrency() {
      let currency = this.currencies.find(x => x.id === this.value.currency_id);
      return currency ? currency : { rank: 1, name: "" };
    },

    toCurrency() {
      let currency = this.currencies.find(
        x => x.id === this.value.receiver_currency_id
      );
      return currency ? currency : { rank: 1, name: "" };
    },

    exchanged: vm =>
      vm.exchange(
        vm.fromCurrency,
        vm.toCurrency,
        curjs(vm.value.amount).value,
        vm.value.rate
      )
  },

  methods: {
    setCustomer(customer) {
      this.customer = customer;
      this.customerChanged(true);
    },
    setReceiver(customer) {
      this.receiver_customer = customer;
      this.customerChanged(false);
    },
    reset() {
      this.customer = this.receiver_customer = {
        type: "new_customer",
        accounts: [],
        details: {}
      };
      this.$validator.reset();
      this.loading = false;
    },

    setPercentage() {
      let am =
        curjs(this.value.amount).value == 0
          ? 1
          : curjs(this.value.amount).value;
      let p = (curjs(this.value.commission_amount).value * 100) / am;
      this.value.commission_percentage = curjs(p).value;
    },

    setCommissionAmount() {
      let p =
        (curjs(this.value.commission_percentage).value *
          curjs(this.value.amount).value) /
        100;
      this.value.commission_amount = curjs(p).value;
    },

    setPaidPercentage() {
      let am =
        curjs(this.value.exchanged).value == 0
          ? 1
          : curjs(this.value.exchanged).value;
      let p = (curjs(this.value.paid_commission_amount).value * 100) / am;
      this.value.paid_commission_percentage = curjs(p).value;
    },
    setPaidCommissionAmount() {
      let p =
        (curjs(this.value.paid_commission_percentage).value *
          curjs(this.value.exchanged).value) /
        100;
      this.value.paid_commission_amount = curjs(p).value;
    },
    setDescription() {
      if (!this.generate_description) return;
      this.value.description = `${this.$t("from_sender")} ${
        this.value.details.name
      } ${this.$t("to_receiver")} ${
        this.value.details.receiver_name
      }  ${this.$t("with_amount_of")} ${this.value.exchanged} ${this.smbl(
        this.value.receiver_currency_id
      )} ${this.$t("with_transafer_no")} (${this.value.number}) ${
        this.sender.name
      } - ${this.receiver.name}`;
    },

    customerChanged(is_send_customer = false) {
      let customer = is_send_customer ? this.customer : this.receiver_customer;

      if (is_send_customer) {
        if (customer.type == "individual") {
          this.value.details.name = customer.name;
          this.value.details.reg_id = customer.id;
          this.value.details.phones = customer.individual.phones;
          this.value.details.father_name = customer.individual.father_name;
          this.value.details.address = customer.individual.current_address;
          this.value.details.occupation = customer.individual.occupation;
          this.value.details.place_of_birth =
            customer.individual.place_of_birth;
          this.value.details.date_of_birth = customer.individual.date_of_birth;
          this.value.details.issue_date = customer.individual.issue_date;
          this.value.details.expire_date = customer.individual.expire_date;
          let doctype = customer.individual.doctype;
          if (doctype == "passport")
            this.value.details.docno = customer.individual.passport_no;
          if (doctype == "tazkira")
            this.value.details.docno = customer.individual.tazkira_no;
          this.value.details.doctype = doctype;
        } else if (customer.type == "corporate") {
          this.value.details.doctype = "license";
          this.value.details.reg_id = this.value.customer_id;
          this.value.details.name = customer.name;
          this.value.details.docno = customer.corporate.license_no;
          this.value.details.address = customer.corporate.business_address;
          this.value.details.phones = customer.corporate.company_phones;
          this.value.details.nature_of_business =
            customer.corporate.nature_of_business;
          this.value.details.issue_date = customer.corporate.license_issue_date;
          this.value.details.expire_date =
            customer.corporate.license_expire_date;
        } else if (customer.type == "external") {
          if (customer.exchange_detail.id) {
            this.value.details = Object.assign({}, customer.exchange_detail);
            delete this.value.details.id;
            delete this.value.details.exchange_id;
          } else if (customer.transfer_detail.id) {
            this.value.details = Object.assign({}, customer.transfer_detail);
            delete this.value.details.id;
            delete this.value.details.transfer_id;
          }
        } else if (customer.type == "new_customer") {
          this.value.details = {
            doctype: "passport",
            reg_id: "TR_" + (this.system.last_customer_reg_number + 1)
          };
        } else {
          this.value.details.name = customer.name;
          this.value.details.phones = customer.phones;
        }
      } else {
        if (customer.type == "individual") {
          this.value.details.receiver_name = customer.name;
          this.value.details.receiver_reg_id = customer.id;
          this.value.details.receiver_phones = customer.individual.phones;
          this.value.details.receiver_father_name =
            customer.individual.father_name;
          this.value.details.receiver_address =
            customer.individual.current_address;
          this.value.details.receiver_occupation =
            customer.individual.occupation;
          this.value.details.receiver_place_of_birth =
            customer.individual.place_of_birth;
          this.value.details.receiver_date_of_birth =
            customer.individual.date_of_birth;
          this.value.details.receiver_issue_date =
            customer.individual.issue_date;
          this.value.details.receiver_expire_date =
            customer.individual.expire_date;
          let doctype = customer.individual.doctype;
          if (doctype == "passport")
            this.value.details.receiver_docno = customer.individual.passport_no;
          if (doctype == "tazkira")
            this.value.details.receiver_docno = customer.individual.tazkira_no;
          this.value.details.receiver_doctype = doctype;
        } else if (customer.type == "corporate") {
          this.value.details.receiver_doctype = "license";
          this.value.details.receiver_reg_id = this.value.customer_id;
          this.value.details.receiver_name = customer.name;
          this.value.details.receiver_docno = customer.corporate.license_no;
          this.value.details.receiver_address =
            customer.corporate.business_address;
          this.value.details.receiver_phones =
            customer.corporate.company_phones;
          this.value.details.receiver_nature_of_business =
            customer.corporate.nature_of_business;
          this.value.details.receiver_issue_date =
            customer.corporate.license_issue_date;
          this.value.details.receiver_expire_date =
            customer.corporate.license_expire_date;
        } else if (customer.type == "external") {
          if (customer.exchange_detail.id) {
            this.value.details = Object.assign({}, customer.exchange_detail);
            delete this.value.details.id;
            delete this.value.details.exchange_id;
          } else if (customer.transfer_detail.id) {
            this.value.details.receiver_name = customer.transfer_detail.name;
            this.value.details.receiver_reg_id =
              customer.transfer_detail.reg_id;
            this.value.details.receiver_phones =
              customer.transfer_detail.phones;
            this.value.details.receiver_father_name =
              customer.transfer_detail.father_name;
            this.value.details.receiver_address =
              customer.transfer_detail.address;
            this.value.details.receiver_occupation =
              customer.transfer_detail.occupation;
            this.value.details.receiver_place_of_birth =
              customer.transfer_detail.place_of_birth;
            this.value.details.receiver_date_of_birth =
              customer.transfer_detail.date_of_birth;
            this.value.details.receiver_issue_date =
              customer.transfer_detail.issue_date;
            this.value.details.receiver_expire_date =
              customer.transfer_detail.expire_date;
            this.value.details.receiver_doctype =
              customer.transfer_detail.doctype;
          }
        } else if (customer.type == "new_customer") {
          this.value.details.doctype = "passport";
          this.value.details.reg_id =
            "TR_" + (this.system.last_customer_reg_number + 1);
        } else {
          this.value.details.receiver_name = customer.name;
          this.value.details.receiver_phones = customer.phones;
        }
      }
      this.setDescription();
    },
    changeFormNumber() {
      this.value.number = Number(this.receiver.last_form_number) + 1;
      this.setDescription();
    },

    currencyChanged() {
      this.value.receiver_currency_id = this.value.currency_id;
      this.value.commission_currency_id = this.value.currency_id;
      this.value.paid_commission_currency_id = this.value.currency_id;
      this.value.rate = 1;
      this.amountChanged(false);
    },

    amountChanged(is_second, set_paid_currency = false) {
      if (is_second) {
        this.value.amount = this.exchange(
          this.toCurrency,
          this.fromCurrency,
          curjs(this.value.exchanged).value,
          this.value.rate
        );
      } else {
        this.value.exchanged = this.exchange(
          this.fromCurrency,
          this.toCurrency,
          curjs(this.value.amount).value,
          this.value.rate
        );
      }
      if (set_paid_currency)
        this.value.paid_commission_currency_id = this.value.receiver_currency_id;
      this.setDescription();
    },

    save(disablePrint = true) {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.receiver.last_form_number = this.value.number;
          if (this.isNewCustomer) {
            this.value.details.reg_id =
              this.value.details.reg_id ||
              (this.system && this.system.last_customer_reg_number++);
          }
          this.value.isNewCustomer = this.isNewCustomer;
          this.value.amount = curjs(this.value.amount).value;
          this.value.exchanged = curjs(this.value.exchanged).value;
          console.log(this.value);
          this.axios
            .post("transfers", this.value)
            .then(async res => {
              let fils = this.value.files.filter(x => !x.id);
              if (fils.length > 0) {
                const fd = new FormData();
                fd.append("fileable_type", "transfer");
                fd.append("fileable_id", res.data.id);
                for (const file of fils) {
                  fd.append("files[]", file);
                }
                await this.axios.post("files", fd, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });
              }
              this.value.time = res.data.time;
              this.value.date = res.data.date;
              await this.getCustomers();
              this.printBill(this.$refs.bill.$el, disablePrint);
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true
              });
              this.$emit("saved", res.data);
              this.reset();
            })
            .catch(error => {
              console.error(error);
              this.$store.commit("showSnackbar", {
                text: error.response.data.message,
                stateType: "error",
                show: true
              });
              this.loading = false;
            });
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
          this.loading = false;
        }
      });
    }
  },
  created() {
    if (this.value.id) {
      this.customer = this.value.customer;
      this.receiver_customer = this.value.receiver_customer;
    }
  }
};
</script>